import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { User } from 'app/core/user/user.types';
import { map, of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);

    // Verifica se o usuário está autenticado
    return authService.isLoggedIn().pipe(
        switchMap((authenticated) => {
            if (!authenticated) {
                // Redireciona para a página de login com a URL atual como parâmetro
                const redirectURL =
                    state.url === '/' ? '' : `redirectTo=${state.url}`;
                return of(
                    router.parseUrl(`/autorizacao/entrar?${redirectURL}`)
                );
            }

            // Caso o usuário esteja autenticado, verifica os papéis (roles)
            return authService.user$.pipe(
                map((user: User) => {
                    const userMeta = user?.user_metadata;
                    const role = route.data.role;

                    switch (role) {
                        case 'ADMIN':
                            if (userMeta.admin) {
                                return true;
                            }
                            break;
                        case 'ADMINSERVICE':
                            if (userMeta.admin || userMeta.adminServices) {
                                return true;
                            }
                            break;
                        case 'REGIONAL_PROJECT':
                            if (userMeta.regionalProject?._id) {
                                return true;
                            }
                            break;
                        case 'REGIONAL_PROJECT_MANAGER':
                            if (userMeta.regionalProject?.isManager) {
                                return true;
                            }
                            break;
                        default:
                            return true; // Permite acesso caso nenhum papel seja especificado
                    }

                    // Redireciona para uma rota padrão se o papel não for atendido
                    return router.parseUrl('/mapa-cidade');
                })
            );
        })
    );
};
